import { render } from "./weixinPay.vue?vue&type=template&id=1005644b&scoped=true"
import script from "./weixinPay.vue?vue&type=script&lang=js"
export * from "./weixinPay.vue?vue&type=script&lang=js"

import "./weixinPay.vue?vue&type=style&index=0&id=1005644b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1005644b"

export default script